/**
 * FreeFic 品牌 - Book 页面配置
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'

/**
 * FreeFic 品牌特定主题配置
 */
export const theme = {
  // 引用装饰线颜色 (FreeFic 使用珊瑚色调,基于主色 #E65F3D)
  quoteColor: 'rgba(230, 95, 61, 0.3)',
  leadTextColor: '#A54B32',
  tagsScrollable: true,
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
